import { defineAsyncComponent } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import { GlTooltipDirective, GlButton, GlDisclosureDropdown, GlDisclosureDropdownItem, GlDisclosureDropdownGroup, GlToastMixin } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
import UserAccessRoleBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/user_access_role_badge.vue?vue3';
import AbuseCategorySelector from '/builds/gitlab/gitlab-ee/app/assets/javascripts/abuse_reports/components/abuse_category_selector.vue?vue3';
import ReplyButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/note_actions/reply_button.vue?vue3';
import EmojiPicker from '/builds/gitlab/gitlab-ee/app/assets/javascripts/emoji/components/picker.vue?vue3';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { copyToClipboard } from '~/lib/utils/copy_to_clipboard';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import * as constants from '~/notes/constants';
export default {
    name: 'NoteActions',
    i18n: {
        editCommentLabel: __('Edit comment'),
        deleteCommentLabel: __('Delete comment'),
        moreActionsLabel: __('More actions'),
        reportAbuse: __('Report abuse')
    },
    components: {
        AbuseCategorySelector,
        EmojiPicker,
        GlButton,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlDisclosureDropdownGroup,
        ReplyButton,
        UserAccessRoleBadge,
        DuoChatFeedbackModal: defineAsyncComponent(()=>import('/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/components/duo_chat_feedback_modal.vue?vue3')),
        ViewSessionButton: defineAsyncComponent(()=>import('/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/shared/widgets/view_session_button.vue?vue3'))
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        Tracking.mixin(),
        GlToastMixin
    ],
    props: {
        authorId: {
            type: Number,
            required: true
        },
        noteId: {
            type: [
                String,
                Number
            ],
            required: false,
            default: ''
        },
        isAmazonQCodeReview: {
            type: Boolean,
            required: false,
            default: false
        },
        noteUrl: {
            type: String,
            required: false,
            default: ''
        },
        accessLevel: {
            type: String,
            required: false,
            default: ''
        },
        isAuthor: {
            type: Boolean,
            required: false,
            default: false
        },
        isContributor: {
            type: Boolean,
            required: false,
            default: false
        },
        noteableType: {
            type: String,
            required: false,
            default: ''
        },
        projectName: {
            type: String,
            required: false,
            default: ''
        },
        showReply: {
            type: Boolean,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        canAwardEmoji: {
            type: Boolean,
            required: false,
            default: false
        },
        canDelete: {
            type: Boolean,
            required: false,
            default: false
        },
        canReportAsAbuse: {
            type: Boolean,
            required: true
        },
        canResolve: {
            type: Boolean,
            required: false,
            default: false
        },
        isResolved: {
            type: Boolean,
            required: false,
            default: false
        },
        isResolving: {
            type: Boolean,
            required: false,
            default: false
        },
        duoSessionId: {
            type: Number,
            required: false,
            default: null
        }
    },
    emits: [
        'award',
        'delete',
        'resolve',
        'start-editing',
        'start-replying'
    ],
    data () {
        return {
            abuseDrawerOpen: false,
            feedbackReceived: false
        };
    },
    computed: {
        shouldShowActionsDropdown () {
            return isLoggedIn();
        },
        showDeleteAction () {
            return this.canDelete && !this.canReportAsAbuse && !this.noteUrl;
        },
        authorBadgeTitle () {
            switch(this.noteableType){
                case constants.COMMIT_NOTEABLE_TYPE:
                    return __('Commit author');
                case constants.MERGE_REQUEST_NOTEABLE_TYPE:
                    return __('Merge request author');
                default:
                    return undefined;
            }
        },
        displayMemberBadgeText () {
            return sprintf(__('This user has the %{access} role in the %{name} project.'), {
                access: this.accessLevel.toLowerCase(),
                name: this.projectName
            });
        },
        displayContributorBadgeText () {
            return sprintf(__('This user has previously committed to the %{name} project.'), {
                name: this.projectName
            });
        },
        resolveIcon () {
            if (this.isResolving) return null;
            return this.isResolved ? 'check-circle-filled' : 'check-circle';
        },
        resolveButtonTitle () {
            return this.isResolved ? __('Reopen thread') : __('Resolve thread');
        }
    },
    methods: {
        async onCopyUrl () {
            await copyToClipboard(this.noteUrl).catch(()=>{});
            this.$toast.show(__('Link copied to clipboard.'));
        },
        showFeedbackModal () {
            this.$refs.feedbackModal.show();
        },
        /**
     * Tracks feedback submitted for Amazon Q code reviews
     * @param {Object} options - The feedback options
     * @param {Array<string>} [options.feedbackOptions] - Array of selected feedback options (e.g. ['helpful', 'incorrect'])
     * @param {string} [options.extendedFeedback] - Additional text feedback provided by the user
     */ trackFeedback ({ feedbackOptions, extendedFeedback } = {}) {
            this.track('amazon_q_code_review_feedback', {
                action: 'amazon_q',
                label: 'code_review_feedback',
                property: feedbackOptions,
                extra: {
                    extendedFeedback,
                    note_id: this.noteId
                }
            });
            this.feedbackReceived = true;
        }
    }
};
